import { h } from 'preact'
import Button from '../../control-components/ui-components/Button'

interface Props {
  'phrases': {
    'title': string
    'body': string
    'button': string
  }
}

const Unsubscribe = ({ phrases }: Props) => {
  return (
    <div className='unsubscribe-wrapper'>
      <div className='unsubscribe-title'>
        {phrases.title}
      </div>
      <div className='unsubscribe-body'>
        {phrases.body}
      </div>
      <div className='unsubscribe-action'>
        <a href='/'><Button primary title={phrases.button} /></a>
      </div>
    </div>
  )
}

export default Unsubscribe
